import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { useAuth } from 'contexts/AuthContext';
import { Link } from 'react-router-dom';

const WelcomeMessage = () => {
  const { user } = useAuth();

  // Don't show if no user data
  if (!user) {
    return null;
  }

  // Get display name (prefer firstName, fallback to username)
  const displayName = user.firstName || user.username || 'User';
  
  // Check if profile is complete (you can customize this logic)
  const isProfileComplete = user.firstName && user.lastName && user.email && user.phone;
  
  return (
    <Card className="mb-4 mt-3 border-1 shadow-sm">
      <Card.Body className="p-4">
        <Row className="align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <div className="flex-1">
                <h4 className="mb-1 text-primary">
                  Welcome back, {displayName}! 
                </h4>
                <p className="text-muted mb-0" style={{fontSize: 13}}>
                  {isProfileComplete 
                    ? "Your profile is complete. You're all set!" 
                    : "Complete your profile to get the most out of your experience."
                  }
                </p>
              </div>
              {!isProfileComplete && (
                <div className="ms-3">
                  <Button 
                    as={Link} 
                    to="/user/profile" 
                    variant="primary" 
                    size="sm"
                    className="px-3"
                  >
                    Complete Profile
                  </Button>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default WelcomeMessage;
